import React, { createContext, useState } from "react";
import * as Constants from '../Common/CommonConstants';
import { getDataByCode, getFormListByCode, getAnonymousDataByCode, reCaptchaResponse, isActiveNAICMember } from '../../services/dataService';

const QuestionnaireCodeContext = createContext([{}, () => { }]);

const QuestionnaireCodeProvider = (props) => {
  const [formState, setFormState] = useState(Constants.ENTER_KEY_MODE);
  const [doneMessage, setDoneMessage] = useState({ message: "", subMessage: "" });
  const [key1, setKey1] = useState("");
  const [key2, setKey2] = useState("");
  const [token, setToken] = useState("");
  const [error, setError] = useState(0);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(null);
  const [formList, setFormList] = useState([]);
  const [unidentifySub, setUnidentifySub] = useState(false);
  const [activeNAICMember, setActiveNAICMember] = useState("");
  // LW251218 CO#4080 Intermediary Page and Security Check Points
  const [searchResult, setSearchResult] = useState("nomatch");
  const [formName, setFormName] = useState("");
  const [stateCode, setStateCode] = useState("");
  const [instanceState, setInstanceState] = useState("");

  const setCompleteState = (props) => {
    setFormState(Constants.DONE_MODE);
      setDoneMessage({ message: "Form has been successfully submitted.", subMessage: "" });
  }

  const updateFormState = (formWasSaved) => {
    if (formState === Constants.READ_ONLY_MODE) {
      setFormState(Constants.DONE_MODE);
      setDoneMessage({ message: "", doneSubMessage: "" })
    }
    else if (formWasSaved) {
      setFormState(Constants.DONE_MODE);
      setDoneMessage({ message: "Form was not saved.", doneSubMessage: "" })
    }
    else {
      setFormState(Constants.DONE_MODE);
      setDoneMessage({ message: "Form saved successfully.", doneSubMessage: "(but not completed)" })
    }
  }


  const openForm = async () => {

    setError(0);
    setLoading(true);

    try {
      var result = await getDataByCode(key1, key2);
      if (result.data.formInfo.status === "COMPLETE")
        setFormState(Constants.READ_ONLY_MODE);
      else
        setFormState(Constants.EDIT_MODE);

      setFormData(result.data);
    }

    catch (e) {
      var errorObj = e;      
      setError(errorObj.request.status);

    }
    finally {
      setLoading(false);
    }

  }

    const openAnonymousForm = async () => {

        setError(0);
        setLoading(true);
        setUnidentifySub(true);

        try {

            //console.log("token=" + token);
            //05292026 - YA#5130 - QA environment reCAPTCHA is enabled
            const showReCaptcha = process.env.REACT_APP_SKIPRECAPTCHA === "TRUE" ? false : true;
            var resp;
            if (showReCaptcha) {
                resp = await reCaptchaResponse(token);
            }
            else
                resp = true;
            //console.log("resp=" + resp);
            if (resp) {
            //get form based on QInstanceId and RecipientId
            var result = await getAnonymousDataByCode(key1, key2);
            if (result.data.formInfo.status === "COMPLETE")
                setFormState(Constants.READ_ONLY_MODE);
            else
                setFormState(Constants.EDIT_MODE);

                setFormData(result.data);
            }
        }

        catch (e) {
            var errorObj = e;
            setError(errorObj.request.status);

        }
        finally {
            setLoading(false);
        }


    }
  const openPortal = async () => {
    setError(0);
    setLoading(true);

    try {
      var result = await getFormListByCode(key1, key2);
      setFormState(Constants.PORTAL_MODE);

      setFormList(result.data);
    }

    catch (e) {
      setError(e.request.status);

    }
    finally {
      setLoading(false);
    }
   
  }

    const checkNAICMemberStatus = async (naicCode, stateCode) => {
        try {
            var result = await isActiveNAICMember(naicCode, stateCode);
            if (result && result.length > 0 ) {
                if (result[0].memberStatus == "active")
                    return "active";
                else
                    return "inactive";
            }
            return "";
        }
        catch (e) {
            return "";
        }
    }

  return (
      <QuestionnaireCodeContext.Provider value={{ formName, setFormName, stateCode, setStateCode, formState, updateFormState, doneMessage, setDoneMessage, key1, setKey1, key2, setKey2, token, setToken, unidentifySub, setUnidentifySub, openForm, openAnonymousForm,  openPortal, formData, setCompleteState, setLoading, loading, formList, error, activeNAICMember, setActiveNAICMember, instanceState, setInstanceState, searchResult, setSearchResult, checkNAICMemberStatus }}>
      {props.children}
    </QuestionnaireCodeContext.Provider>
  )
}

export { QuestionnaireCodeContext, QuestionnaireCodeProvider };